export const home = '/'
export const dailyShuffle = '/DailyShuffle/'
export const classicShuffle ='/ClassicShuffle/'
export const liteShuffle ='/LiteShuffle/'